<template>
  <div
    class="instrumental-create-advance"
    :class="{
      'instrumental-create-advance--mobile': createRenderType == 'mobile',
    }"
  >
    <div class="instrumental-create-advance-refer-label">
      {{ $$t("editor.add_reference") }}
    </div>

    <div class="instrumental-create-advance-refer-description">
      {{ $$t("editor.add_reference_description") }}
    </div>

    <div class="instrumental-create-advance-addreference">
      <AddReference></AddReference>
    </div>

    <div class="instrumental-create-advance-label">
      {{ $$t("editor.title") }}
    </div>

    <div
      class="instrumental-create-advance-song-name"
      @click="onSongNameBoxClick"
    >
      <input
        type="text"
        :placeholder="$$t('editor.optional')"
        ref="refSongName"
        v-model="renderData.songName"
        @input="onSongNameInput"
        @change="onSongNameChange"
      />
      <div
        class="instrumental-create-advance-song-name-count"
        :class="{
          'color-red': renderData.songName?.length >= 50,
        }"
      >
        {{ `${renderData.songName?.length ?? 0} / 50` }}
      </div>
    </div>
    <div class="create-submit tc pointer">
      <div
        class="create-submit-credits fn-inline"
        @click="
          () => {
            if (
              modelDataStore.default_model?.free_to_use &&
              createRenderType != 'mobile'
            ) {
              goBuyCredits();
            }
          }
        "
      >
        <!-- <i class="create-submit-credits-ico credits-ico fn-inline"></i> -->
        <div
          class="create-submit-button-model-use-first-label fn-inline"
          v-if="
            modelDataStore.default_model?.free_to_use &&
            createRenderType != 'mobile'
          "
        >
          {{ $$t("create.first_free") }}
        </div>
        <span class="create-submit-credits-text fn-inline" v-else>
          {{ $$t("create.credits_remaining") }}
          {{ renderData.userCredits }}
        </span>
        <!-- <i class="create-submit-credits-ico arrow-ico fn-inline"></i> -->
      </div>
      <div
        ref="refCreateSubmitButton"
        class="create-submit-button fn-inline create-submit-button-disabled"
        :class="{
          'driver-high-breathe':
            !isLogin && curDriverKey == 'click_to_generate_song--not',
        }"
      >
        <Bubble
          :disabled="!renderData.disabled"
          :content="$$t('editor.create_bgm_btn_tip')"
          placement="top"
        >
          <Button
            @click="
              () => {
                doGernerate();
              }
            "
            :disabled="renderData.disabled"
            :loading="renderData.isLoading"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': createRenderType == 'mobile' ? '56px' : '48px',
              '--borderRadius': createRenderType == 'mobile' ? '56px' : '48px',
              '--background':
                'linear-gradient(263deg, rgba(137, 122, 255, 1) 0%, rgba(255, 216, 203, 1) 50%, rgba(177, 146, 255, 1) 100%)',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover':
                'linear-gradient(263deg, rgba(137, 122, 255, 0.75) 0%, rgba(255, 216, 203, 0.75) 50%, rgba(177, 146, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            <div class="flex-center btn-content">
              <span class="ico fn-inline"></span>
              <span class="fn-inline">{{ $$t("create.create") }}</span>
              <div
                class="create-submit-button-model-use-first fn-inline"
                v-if="
                  modelDataStore.default_model?.free_to_use &&
                  createRenderType == 'mobile'
                "
              >
                {{ $$t("create.first_free") }}
              </div>
            </div>
          </Button>
        </Bubble>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";
import Button from "@/components/basic/button/Button.vue";

import AddReference from "@/page/instrumental/createAdvance/addReference.vue";
import globleConfig from "@/config/config.js";
import tools from "@/utils/tools.js";
import {
  $$language,
  $$t,
  $$registLanguageChangeListener,
  $$removeLanguageChangeListener,
} from "@/i18n/i18n.js";

import useDraftDataStore from "@/store/create/draftDataStore.js";
const draftDataStore = useDraftDataStore();
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import { storeToRefs } from "pinia";
import useDiverStore from "@/store/driverStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";
import useGlobalUserStateStore from "@/store/globalUserStateStore.js";

import useBgmReferMusicStore from "@/store/create/bgmReferMusicStore.js";
import useModelDataStore from "@/store/model/modelDataStore.js";

const globalPlayDataStore = useGlobalPlayDataStore();
const { curPlayData } = storeToRefs(globalPlayDataStore);
const driverStore = useDiverStore();
const createLayoutStore = useCreateLayoutStore();
const globalUserStateStore = useGlobalUserStateStore();
const bgmReferMusicStore = useBgmReferMusicStore();
const modelDataStore = useModelDataStore();

const { curDriverKey } = storeToRefs(driverStore);
const {
  createRenderType,
  bgmCreate_createEditOpenState,
  nobgmCreate_createEditOpenState,
  globalPlayerOpened,
  bgmCreateEditMode,
  createEditGuidTourVisible,
  vocalCornerMarkVisible,
} = storeToRefs(createLayoutStore);

const feedListDataStore = useFeedListStore();
const userDataStore = useUserDataStore();
const { isLogin } = storeToRefs(userDataStore);
import { useRouter, useRoute } from "vue-router";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const Router = useRouter();
const route = useRoute();

const props = defineProps({
  similarData: {
    type: Object,
    default: null,
  },
});
const emits = defineEmits([]);

const refSongName = ref(null);

const renderData = reactive({
  disabled: false,
  userCredits: userDataStore.isLogin ? userDataStore.credits ?? 0 : 0,
  createTipText: "",
  isLoading: false,
  ifRender: true,
  editBoxHeight: "100%",
  createHasInit: false,
  songName: "",
});

const onSongNameBoxClick = () => {
  refSongName.value?.focus();
};

const onSongNameInput = (e) => {
  renderData.songName = e.target.value.slice(0, 50);
};

const onSongNameChange = (e) => {
  renderData.songName = e.target.value.slice(0, 50);
};

const closeCreateEdit = (e) => {
  e ??= window.event;
  e.preventDefault();
  createLayoutStore.toggleBgmCreateEditOpenState(false);
};

const openCreateEdit = () => {
  createLayoutStore.toggleBgmCreateEditOpenState(true);
};

const doGernerate = async (isInit) => {
  const feedData = draftDataStore.getBgmGenerateAdvanceDraftData();
  globalProperties.logClickEvent("create_instrument_advanced_mode", {
    type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    similar: props.similarData ? "true" : "false",
  });

  driverStore.setcurDriverKey("");
  if (
    !(await userDataStore.checkLoginStatus(
      {
        rightType: "generate", //"generate",
        create_type: "1",
        generate: "0",
      },
      (isLogin) => {
        if (isLogin) {
          doGernerate(true);
        }
        console.log("doGernerate_advanced");
        localStorage.removeItem(`${globleConfig.appname}_create_data`);
      }
    ))
  ) {
    localStorage.setItem(
      `${globleConfig.appname}_create_data`,
      JSON.stringify({
        type: "bgmadvanced",
        timeScamps: new Date().getTime(),
        refer: bgmReferMusicStore.curUseReferMusic,
        title: bgmReferMusicStore.songName,
      })
    );
    globalProperties.logClickEvent("newuser_create_instrument_advanced_mode", {
      type: userDataStore.isLogin ? "sign_in" : "not_sign_in",
    });
    return;
  }

  const model = modelDataStore.default_model;
  renderData.isLoading = true;
  feedListDataStore
    .doBgmGernerate(isInit, {
      membership_source1: "instrumental",
      membership_source2: props.similarData
        ? "create_advance_similar"
        : "create_advance",
    })
    .then(() => {
      renderData.isLoading = false;
      renderData.createEditOpenState = "min";
      modelDataStore.changeFreeState(model);
    })
    .catch((e) => {
      renderData.isLoading = false;
    });
};

const goBuyCredits = () => {
  createLayoutStore.toggleBgmCreateEditOpenState(false);
  Router.push({
    name: "subscribe",
    query: {
      membership_source1: "instrumental",
      membership_source2: props.similarData
        ? "create_advance_similar"
        : "create_advance",
    },
  });
};

watch(
  () => {
    return userDataStore.credits;
  },
  () => {
    renderData.userCredits = userDataStore.credits ?? 0;
  }
);

watch(
  () => {
    return renderData.songName;
  },
  (newVal) => {
    bgmReferMusicStore.setSongName(newVal);
  }
);

watch(
  () => {
    return bgmReferMusicStore.songName;
  },
  (newVal) => {
    renderData.songName = newVal;
  }
);

watch(
  () => {
    return userDataStore.isLogin;
  },
  () => {
    renderData.userCredits = userDataStore.isLogin
      ? userDataStore.credits ?? 0
      : 2;

    if (userDataStore.isLogin) {
      nextTick(() => {
        setTimeout(() => {
          initGenerate();
        }, 20);
      });
    }
  }
);

const initGenerate = () => {
  console.log("initGenerate_advanced");
  if (userDataStore.isLogin) {
    let _create_data = localStorage.getItem(
      `${globleConfig.appname}_create_data`
    );
    try {
      _create_data = JSON.parse(_create_data);
      if (_create_data) {
        if (new Date().getTime() - _create_data?.timeScamps < 1000 * 60 * 60) {
          if (_create_data.type == "bgmadvanced") {
            nextTick(() => {
              bgmReferMusicStore.setSongName(_create_data.title);
              bgmReferMusicStore.setCurUseReferMusic(_create_data.refer);
            }).then(() => {
              doGernerate(true);
              localStorage.removeItem(`${globleConfig.appname}_create_data`);
              createLayoutStore.toggleBgmCreateEditOpenState(true);
              createLayoutStore.setBgmCreateEditMode("hard");
            });
          }
        }
      } else {
        _create_data = null;
        localStorage.removeItem(`${globleConfig.appname}_create_data`);
      }
    } catch (e) {
      _create_data = null;
      localStorage.removeItem(`${globleConfig.appname}_create_data`);
    }
  } else {
    localStorage.removeItem(`${globleConfig.appname}_create_data`);
  }
};

onMounted(async () => {
  console.log("🍎🍎🍎🍎createEdit mounted", route);
  if (!props.similarData) {
    renderData.bgmCreateEditMode = createLayoutStore.bgmCreateEditMode;
  }
  renderData.songName = bgmReferMusicStore.songName;
  renderData.disabled = !bgmReferMusicStore.curUseReferMusic;
  nextTick().then(() => {
    if (userDataStore.isLogin) {
      initGenerate();
    }
  });
  if (userDataStore.isLogin) {
    userDataStore.refreshUserAccount();
  }
});

watch(
  () => bgmReferMusicStore.curUseReferMusic,
  (newVal) => {
    renderData.disabled = !newVal;
  }
);
</script>
<style lang="scss">
.instrumental-create-advance {
  height: 100%;
  display: flex;
  flex-direction: column;

  .instrumental-create-advance-refer-label {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0em;
    color: #ffffff;
  }

  .instrumental-create-advance-refer-description {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 8px;
  }

  .instrumental-create-advance-addreference {
    height: 0;
    flex: 1;
  }
  .instrumental-create-advance-label {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #ffffff;
    margin: 11px 0 8px 0;
  }
  .instrumental-create-advance-song-name {
    height: 56px;
    border-radius: 12px;
    align-items: center;
    position: relative;

    background: linear-gradient(
      262deg,
      rgba(255, 212, 197, 0.2) 0%,
      rgba(122, 157, 255, 0.2) 100%
    );
    input {
      height: 100%;
      border: none;
      background: none;
      padding: 15px 65px 15px 15px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      line-height: 24px;
      color: #fff;
      width: 100%;
      border-radius: 12px;
      border: 1px solid transparent;
      &:focus {
        outline: none;
        border: 1px solid #94adff;
      }
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .instrumental-create-advance-song-name-count {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: 300;
      line-height: 16px;
      color: rgba(255, 255, 255, 0.5);
      padding: 0 16px 0 0;
      position: absolute;
      right: 0;
      top: 0;
      line-height: 56px;
      pointer-events: none;
      &.color-red {
        color: #ff5f74;
      }
    }
  }
  .create-submit {
    margin: 20px 0 0 0px;
    height: 48px;
    border-radius: 60px;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: #fff;
    border-radius: 50px;
    background: rgba(255, 255, 255, 0.1);
    padding: 0 0 0 10px;
    .el-button {
      .el-icon.is-loading {
        background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
      }
    }
    .create-submit-credits {
      width: calc(100% - 150px);
      text-align: left;
      padding: 0 6px 0 4px;
      .credits-ico {
        height: 16px;
        width: 16px;
        background-image: url("@/assets/img/database-ico.png");
        background-size: 100% 100%;
      }
      .arrow-ico {
        height: 16px;
        width: 16px;
        background-image: url("@/assets/img/arrow-right-ico.png");
        background-size: 100% 100%;
      }
      span {
        margin: 0 4px;
      }
      &:hover {
        color: #94adff;
      }
      .create-submit-button-model-use-first-label {
        font-family: HarmonyOS Sans SC;
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0.02em;
        background: linear-gradient(
          106deg,
          #ffe08b 0%,
          #fff7d0 47%,
          #ffe08b 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
    }
    .create-submit-button {
      width: 150px;
      position: relative;
      .btn-content {
        position: relative;
      }
      .create-submit-button-model-use-first {
        position: absolute;
        top: -8px;
        left: 110%;
        height: 22px;
        padding: 0 8px 0 8px;
        border-radius: 16px 20px 20px 0px;
        /* 自动布局 */
        display: flex;
        flex-direction: column;
        background: linear-gradient(
          112deg,
          #ffe08b 0%,
          #fff7d0 47%,
          #ffe08b 100%
        );
        line-height: 22px;
        font-family: HarmonyOS Sans SC;
        font-size: 10px;
        font-weight: 400;
        color: #000;
      }
    }
  }

  &.instrumental-create-advance--mobile {
    .instrumental-create-advance-refer-description {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 8px;
    }
    .instrumental-create-advance-song-name {
      height: 48px;
      .instrumental-create-advance-song-name-count {
        line-height: 48px;
      }
    }
    .create-submit {
      padding: 20px 16px 20px 16px;
      margin: 0;
      height: 96px;
      background: linear-gradient(180deg, rgba(5, 16, 47, 0) 0%, #05102f 52%);
      margin: 0 -16px;
      border-radius: 0;
      .create-submit-button {
        border-radius: 48px;
      }
      .create-submit-credits {
        display: none;
      }
      .create-submit-button {
        width: 100%;
        span.ico {
          width: 24px;
          height: 24px;
          background-image: url("@/assets/img/music-ico-white.png");
          background-size: 100% 100%;
          margin-right: 5px;
          display: none;
        }
      }
    }
  }
}
</style>
